import { useState } from 'react';
import { PageLayoutsContainer } from '@wajeez-web/components/layouts';
import { Server } from '@wajeez-web/core/api-base';
import {
  ContentEntityTypeNavigationsActions,
  SystemConfigsActions,
  useContentSelector,
} from '@wajeez-web/stores/content';
import { SuperAdminSystemPermissions } from '@wajeez-web/core/types';
import { HandleTableData } from '@wajeez-web/components/data-table';
import { contentEntityDataType } from '@wajeez-web/stores/content';
import { CheckBoxType } from '@wajeez-web/components/mui';
import {
  DataTableWrapper,
  useContentEntityTypeNavigationsDataTable,
} from '@wajeez-web/components/helpers';
import { Button } from '@wajeez-web/components/ui';
import { PlusIcon } from '@heroicons/react/solid';
import { useNavigate } from 'react-router-dom';

export const ContentEntityTypeNavigationsPage = () => {
  const navigate = useNavigate();

  const [
    isContentEntityTypeNavigationModalOpen,
    setIsContentEntityTypeNavigationModalOpen,
  ] = useState(false);
  const [
    selectedContentEntityTypeNavigation,
    setSelectedContentEntityTypeNavigation,
  ] = useState<Partial<Server.UpdateContentEntityTypeNavigationInput>>();

  const dataTable = useContentEntityTypeNavigationsDataTable();

  const { tablePreferances, setTablePreferences, isTableReferencesLoading } =
    HandleTableData(
      'contentEntityTypeNavigations',
      ContentEntityTypeNavigationsActions.getContentEntityTypeNavigationsDataTableAsync
    );

  return (
    <div className="h-full">
      <PageLayoutsContainer
        title={`Type Navigations`}
        withoutRightPadding={false}
        endSideComponent={[
          {
            element: (
              <Button
                title={'Create Type Navigation'}
                Icon={PlusIcon}
                onClick={() => {
                  navigate('/type-navigations/new');
                }}
                bg="primary"
                color="white"
              />
            ),
            permission: [
              SuperAdminSystemPermissions.contentEntityTypeNavigations.add,
            ],
          },
        ]}
        breadCrumbsLinks={[{ title: 'Type Navigations' }]}
      >
        <DataTableWrapper
          data={dataTable.data as contentEntityDataType}
          onHeaderManage={(header) => {
            const flags = header
              ?.filter((h) => h.selected)
              .reduce(
                (previousValue: number, currentValue: CheckBoxType) =>
                  previousValue + Number(currentValue.value),
                0
              );

            tablePreferances &&
              flags &&
              setTablePreferences({
                ...tablePreferances,
                flags: flags + 1,
              });
          }}
          onPaginationChange={(pagination) => {
            tablePreferances &&
              setTablePreferences({
                ...tablePreferances,
                pageNumber: pagination.pageNumber,
                pageSize: pagination.pageSize,
              });
          }}
          sort={tablePreferances?.sortingOperations?.[0]}
          onSort={(sort) => {
            tablePreferances &&
              setTablePreferences({
                ...tablePreferances,
                sortingOperations: [sort],
              });
          }}
          onFilter={(filters, pagination) => {
            tablePreferances &&
              setTablePreferences({
                ...tablePreferances,
                pageNumber: pagination.pageNumber,
                filteringOperations: filters.map((f) => {
                  return {
                    property: Number(f.key),
                    cretiria: f.value,
                    comparisonType: f.operator,
                  };
                }),
              });
          }}
          isLoading={dataTable.status === 'loading'}
          rowActions={(row) => {
            return [
              {
                title: 'Edit',
                permission:
                  SuperAdminSystemPermissions.contentEntityTypeNavigations.edit,
                endpoint: '',
                type: 'request',
                action: () => {
                  navigate(`/type-navigations/${row[1]}/edit`);
                },
              },
            ];
          }}
          preferences={tablePreferances || undefined}
          setPreferences={setTablePreferences}
        />
      </PageLayoutsContainer>
    </div>
  );
};
